/**
 *
 * Login
 *
 */

import React, { useReducer, useRef } from 'react';

import { Input, Button, Text } from 'components/common';
import HomeIllustration from 'assets/images/home.png';
// import ProdigalVoiceLogo from 'assets/images/prodigalvoice-logo.png';

import { validateEmail } from 'utils/commonFunctions';
import {
  UNEXPECTED_LOGIN_ERROR,
  PRODIGAL_LOGO_LIGHT,
} from 'utils/commonConstants';
import Auth from 'auth0-react';
import { CustomLoginError } from 'components';

import { loginReducer, initialState } from './reducer';

import styles from './style.module.css';

export const auth = new Auth();

// eslint-disable-next-line sonarjs/cognitive-complexity
export function Login() {
  // use ref for un-controlled inputs, i.e, doesn't need value in to operate. (preventing re-renders from input)
  const username = useRef('');
  const password = useRef('');
  const [
    { usernameError, passwordError, loginError, loginInProgress },
    dispatch,
  ] = useReducer(loginReducer, initialState);

  /**
   * @param param0 Object for username, password anf login error, states, to dispatch, as login.
   */
  const handleLogin = ({
    loginErrorArg,
    usernameErrorArg,
    passwordErrorArg,
    loginInProgressArg,
  }: any) => {
    dispatch({
      type: 'login',
      payload: {
        loginError: loginErrorArg,
        usernameError: usernameErrorArg,
        passwordError: passwordErrorArg,
        loginInProgress: loginInProgressArg,
      },
    });
  };

  /**
   * @param param0 Object for username, password anf login error, states, to dispatch, as login error.
   */
  const handleLoginError = ({
    usernameErrorArg,
    passwordErrorArg,
    loginInProgressArg,
  }: any) => {
    dispatch({
      type: 'loginError',
      payload: {
        usernameError: usernameErrorArg,
        passwordError: passwordErrorArg,
        loginInProgress: loginInProgressArg,
      },
    });
  };

  const onChangePassword = (e: any) => {
    password.current = e.target.value;
  };

  const onChangeEmail = (e: any) => {
    username.current = e.target.value;
  };
  /**
   * Verifies the input Credentials, and Authorizes else, updates with an error message.
   */
  const onLogin = () => {
    let newUsernameError = '';
    let newPasswordError = '';
    if (!username.current) {
      newUsernameError = 'Email cannot be empty';
    }
    if (!password.current) {
      newPasswordError = 'Password cannot be empty';
    }
    handleLogin({
      loginErrorArg: '',
      usernameErrorArg: newUsernameError,
      passwordErrorArg: newPasswordError,
      loginInProgressArg: true,
    });
    if (username.current && password.current) {
      auth.authorize(
        username.current,
        password.current,
        (errorMessage: any) => {
          handleLogin({
            loginErrorArg: errorMessage,
            usernameErrorArg: newUsernameError,
            passwordErrorArg: newPasswordError,
            loginInProgressArg: false,
          });
          localStorage.removeItem('redirect_location');
        },
      );
    } else {
      handleLoginError({
        usernameErrorArg: newUsernameError,
        passwordErrorArg: newPasswordError,
        loginInProgressArg: false,
      });
    }
  };

  /**
   * Prompts with messsages for password recovery.
   */
  const onForgotPassword = () => {
    let newUsernameError = '';
    if (!username.current) {
      newUsernameError = 'Please enter your email ID';
    } else if (!validateEmail(username.current)) {
      newUsernameError = 'Please enter a valid email ID';
    }
    handleLogin({
      loginErrorArg: '',
      usernameErrorArg: newUsernameError,
      passwordErrorArg: '',
      loginInProgressArg: true,
    });
    if (username.current && validateEmail(username.current)) {
      auth.handleForgotPassword(username.current, (err: any) => {
        if (err)
          handleLoginError({
            usernameErrorArg: newUsernameError,
            loginInProgressArg: false,
          });
        else {
          handleLogin({
            loginErrorArg:
              'If this is a valid email registered with us, further instructions will be sent to it. If you don’t receive a message in 5 minutes, please check the junk folder. If you are still experiencing any problems, contact support at support@prodigaltech.com',
            loginInProgressArg: false,
            usernameErrorArg: '',
            passwordErrorArg: '',
          });
        }
      });
    } else {
      handleLogin({
        loginErrorArg: '',
        usernameErrorArg: newUsernameError,
        loginInProgressArg: false,
        passwordErrorArg: '',
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginHolder}>
        <div className={styles.leftPane}>
          <div className={styles.logoHolder}>
            <Text type="title" text="Welcome to" />
            <img
              src={PRODIGAL_LOGO_LIGHT}
              className={styles.logoImg}
              alt="Logo"
              title="Prodigal"
            />
          </div>
          <div className={styles.loginForm}>
            <p className={styles.errorText}>
              {loginError === UNEXPECTED_LOGIN_ERROR ? (
                <CustomLoginError />
              ) : (
                loginError
              )}
            </p>
            <div className={styles.inputFields}>
              <Text type="subtitle" text="Email ID" />
              <Input
                type="email"
                name="username"
                backgroundColor="#ffffff"
                placeholder="yours@example.com"
                onChange={onChangeEmail}
                onPressEnter={() => onLogin()}
              />
              <p className={styles.errorText}>{usernameError}</p>
            </div>
            <div className={styles.inputFields}>
              <Text type="subtitle" text="Password" />
              <Input
                type="password"
                name="password"
                backgroundColor="#ffffff"
                // prefix={<Icon type="key" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Your password"
                onChange={onChangePassword}
                onPressEnter={() => onLogin()}
                visibilityToggle
              />
              <p className={styles.errorText}>{passwordError}</p>
            </div>
            <Button
              type="reset-link"
              text="Forgot Password?"
              width="fit-content"
              onClick={onForgotPassword}
            />
            <Button
              loading={loginInProgress}
              type="primary"
              height="50px"
              onClick={() => onLogin()}
              text="LogIn"
              texttransform="uppercase"
            />
          </div>
        </div>
        <div className={styles.rightPane}>
          <img className={styles.illustration} src={HomeIllustration} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Login;
